/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import CancelAction from './CancelAction/index'
import DeleteAction from './DeleteAction/index'
import React from 'react'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Charges/ActionsAction/Content/Content/DeleteAction/Confirmation/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 size="medium"
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 text="Delete charges"
/>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text="Are you sure you want to delete all the selected charges?"
/>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
/>
<DeleteAction
{...childProps}
  viewPath={`${viewPath}/DeleteAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}